$('.js-search-filter-btn').on('click', function() {
    const $button = $(this);
    const $searchFilter = $button.closest('.js-search-filter');
    const searchFilterUrl = $searchFilter.data('url');
    const searchFilterMethod = $searchFilter.data('method') || 'GET';
    const searchFilterName = $searchFilter.data('search');
    const searchQuery = {
        query: $('.js-search-query').val(),
        filter: searchFilterName
    };

    $('.js-search-filter-btn').removeClass('_active');
    $button.addClass('_active');

    $.ajax({
        url: searchFilterUrl,
        method: searchFilterMethod,
        data: searchQuery,
        success: function (data) {
            if (data.success) {
                if (data.results && data.results.length > 0) {
                    $('.js-search-list').html('').append(data.results);
                } else {
                    $('.js-search-list').html('');
                }
                if (data.pagination && data.pagination.length > 0) {
                    $('.js-pagination').html('').append(data.pagination);
                } else {
                    $('.js-pagination').html('');
                }

                if (App.W.width() < 768) {
                    $button.closest('.js-dropdown').find('.js-dropdown-button span').html($button.html());
                    $(".js-dropdown._opened").removeClass("_opened");
                    $(".js-dropdown-content").slideUp(150);
                    App.lockScroll.unlock();
                }
            }
        }
    });
});